<script lang="ts">
export default {
  name: 'HeaderAccount',
  inheritAttrs: false,
  customOptions: {}
}
</script>

<script setup lang="ts">
import { useGlobalStore } from '../stores/global';

defineProps({
  login_url: {type: String, required: true},
  account_url: {type: String, required: true},
  account_url_my_organisation: {type: String, required: true},
  account_url_my_details: {type: String, required: true},
  account_url_invoices: {type: String, required: true},
  logout_url: {type: String, required: true},
  favorites_url: {type: String, required: true},
  trans: {type: Object, required: true},
});

const store = useGlobalStore();
</script>

<template>
  <a class="link" :href="store.user.id ? account_url : login_url"><i class="ico-user-solid"></i><span>{{ store.user.id ? trans.account : trans.login }}</span></a>

  <a v-if="store.user.id" :href="favorites_url" id="all-favorites" :class="store.user.num_favorites > 0 ? 'icon-favorites' : 'icon-favorites-o'">
    <span v-show="store.user.num_favorites > 0">{{store.user.num_favorites}}</span>
  </a>

  <div v-if="store.user.id" class="header-account-submenu">
    <ul>
      <li>
        <a :href="account_url_my_details">{{ trans.account_my_details }}</a>
      </li>
      <li v-if="store.user.isIntermediary || store.user.isFranchise">
        <a :href="account_url_my_organisation">{{ trans.account_my_organisation }}</a>
      </li>
      <li>
        <a :href="account_url_invoices">{{ trans.account_invoices }}</a>
      </li>
      <li>
        <a :href="logout_url">{{ trans.account_logout }}</a>
      </li>
    </ul>
  </div>

</template>
